/**
 * liveBrowserAdapter — faut-il proposer un autre navigateur avant le live, et lequel ?
 *
 * La règle de l'ancien `PreCallScreen` : Chrome sur un ordinateur passe droit au test ; ailleurs sur
 * le web (un autre navigateur, ou le navigateur d'un téléphone), le choix du navigateur s'interpose,
 * avec sa sortie « Continuer sur ce navigateur ». Dans l'app, jamais.
 *
 * Et où mène son bouton : Chrome à installer sur un ordinateur, la fiche de l'app sur un téléphone.
 * La résolution de la fiche est celle de `common/utils/storeLinks` (lien de la configuration
 * serveur, puis celui du build, puis le lien de repli), que les ports ne lisent pas : recopiée ici,
 * en pur, testée.
 */
export type LiveBrowserDevice = "computer" | "phone"

/** `isChrome()` et `isWebMobile()` de `common/utils/mobileUtils`, sur une signature donnée. */
export function liveBrowserChoiceFor(args: { isWeb: boolean; userAgent: string }): LiveBrowserDevice | null {
    if (!args.isWeb) return null
    const ua = args.userAgent.toLowerCase()
    const phone = /android|iphone|kindle|ipad/i.test(args.userAgent)
    const chrome = ua.includes("chrome") && !ua.includes("opr") && !ua.includes("edg")
    if (chrome && !phone) return null
    return phone ? "phone" : "computer"
}

export const CHROME_DOWNLOAD_URL = "https://www.google.com/intl/fr_fr/chrome/"

const FALLBACK_STORE_URLS = {
    ios: "https://apps.apple.com/app/masteur/id1614253966",
    android: "https://play.google.com/store/apps/details?id=com.masteur.app",
}

export type LiveStore = "ios" | "android"

export function liveStoreFor(userAgent: string): LiveStore {
    return /android/i.test(userAgent) ? "android" : "ios"
}

/** La fiche de l'app : la configuration serveur, sinon celle du build, sinon le lien de repli. */
export function liveStoreUrl(
    store: LiveStore,
    urls: {
        iosAppUrl?: string | null
        androidAppUrl?: string | null
        buildIos?: string | null
        buildAndroid?: string | null
    }
): string {
    return store === "android"
        ? urls.androidAppUrl?.trim() || urls.buildAndroid || FALLBACK_STORE_URLS.android
        : urls.iosAppUrl?.trim() || urls.buildIos || FALLBACK_STORE_URLS.ios
}

/** L'adresse à taper dans Chrome, sans son protocole. */
export function appDomainOf(appUrl: string): string {
    return appUrl.replace(/^https?:\/\//, "")
}
